import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { CmsService, Page } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { EMPTY, Observable, Subscription, combineLatest, forkJoin, of } from 'rxjs';
import { map, mergeMap, take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { DiscountsService } from 'src/app/service/myaccount/discounts.service';

export interface ShimanoDiscountBucket {
  code: string;
  name: string;
}

@Component({
  selector: 'app-discount-type',
  templateUrl: './discount-type.component.html',
  styleUrls: ['./discount-type.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DiscountTypeComponent implements OnInit, OnDestroy {
  discountType$: Observable<any> = this.componentData.data$;
  shimanoDiscountBuckets: ShimanoDiscountBucket[] = [];
  discountBucketActive: string;
  activeI = 0;

  isMobile = false;
  cxMobileWidth = this.breakpointService.getSize(BREAKPOINT.sm);

  discountTypeSubscription: Subscription;

  constructor(
    private componentData: CmsComponentData<any>,
    private cmsService: CmsService,
    private discountsService: DiscountsService,
    private componentService: ComponentService,
    private breakpointService: BreakpointService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.isMobile = window.innerWidth < this.cxMobileWidth;

    this.discountTypeSubscription = this.cmsService
      .getCurrentPage()
      .pipe(
        mergeMap((currentPage) => forkJoin([this.discountsService.getShimanoDiscountBuckets(), of(currentPage)])),
        mergeMap(([buckets, currentPage]: [any, Page]) => {
          const bucketDetails$ = combineLatest(
            buckets.enums.map((bucket: any) =>
              this.discountsService.getShimanoDiscountBucketDetails(bucket.code).pipe(
                map((details) => {
                  return Object.keys(details).length ? { code: bucket.code, details } : null;
                })
              )
            )
          );
          return forkJoin([of(buckets), of(currentPage), bucketDetails$]);
        }),
        mergeMap(([buckets, currentPage, bucketDetails]: [any, any, any]) => {
          let discountParagraphCodes: string[] = [];
          this.shimanoDiscountBuckets = [];
          if (currentPage && currentPage.template === 'MyAccountDiscountsPageTemplate') {
            currentPage.slots.BodyContent.components
              .filter((p: any) => p.typeCode === 'ShimanoParagraphComponent')
              .map((p: any) =>
                this.cmsService
                  .getComponentData<any>(p.uid)
                  .pipe(take(1))
                  .subscribe((d) => {
                    discountParagraphCodes.push(d.styleClass.split('_')[1]);
                  })
              );
            if (bucketDetails) {
              this.discountsService.shimanoDiscountBucketDetails$.next(bucketDetails);
            }
            return of(
              buckets.enums.filter(
                (bucket: ShimanoDiscountBucket) =>
                  discountParagraphCodes.includes(bucket.code) ||
                  bucketDetails.some((bucketDetail: any) => bucketDetail && bucketDetail.code === bucket.code)
              )
            );
          } else {
            return EMPTY;
          }
        })
      )
      .subscribe((buckets) => {
        if (buckets) {
          this.shimanoDiscountBuckets = buckets;
          this.discountBucketActive = this.shimanoDiscountBuckets[this.activeI].code;
          this.componentService.setDiscountType(this.discountBucketActive);
        }
        this.cdr.detectChanges();
      });
  }

  onClickDiscountBucket(bucket: ShimanoDiscountBucket, index: number) {
    this.activeI = index;
    this.discountBucketActive = bucket.code;
    this.componentService.setDiscountType(this.discountBucketActive);
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth < this.cxMobileWidth;
  }

  ngOnDestroy() {
    if (this.discountTypeSubscription) {
      this.discountTypeSubscription.unsubscribe();
    }
  }
}
